import { useState, useEffect, useRef } from "react";
import { CircularProgress } from "@mui/material";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import SearchIcon from "../assets/searchIcon.svg";
import Animation from "../assets/checkcirclepng.png";
import RedAnimation from "../assets/RedAnimation.gif";
import StartedManually from "../assets/warnorange.png";
import RunningAnimation from "../assets/ActiveAnimation.gif";
import "./ManageRpa.scss";
import CustomPagination from "../utils/paginationUtils";
import { RpaServices } from "../services/RpaServices";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Select from "react-select";
import { HospitalServices } from "../services/HospitalServices";
import InfoIcon from "../assets/eyeIcon.svg";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import yellow from "../assets/yellow.png";
import Close from "@mui/icons-material/Close";
import { fetchNewCaseNotificationCount } from "../redux/notificationSlice";
import { useDispatch, useSelector } from "react-redux";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import AddNewCaseFromRpa from "./AddNewCaseFromRpa";
import AddPmjayQuery from "./AddPmjayQuery";
import DownloadDocumentsForRpa from "./DownloadDocumentsForRpa";
import UpdateMultipleRequestStatus from "./UpdateMultipleRequestStatus";
const ManagedRpaLogs = () => {
  const newCaseKey = new URLSearchParams(window.location.search).get("newCase");

  const [isPasswordVisible, setIsPasswordVisible] = useState(null);
  const [rpaLogs, setRpaLogs] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [searchKey, setSearchKey] = useState("");
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [newStatus, setnewStatus] = useState("NEW");
  const [selectedUser, setSelectedUser] = useState(null);
  const [hospitalId, setHospitalId] = useState("");
  const [selectedHospital, setSelectedHospital] = useState("");
  const [selectedApplication, setSelectedApplication] = useState("");
  const [requestStatus, setRequestStatus] = useState(
    newCaseKey ? "NEW" : "STARTMANUALLY",
  );
  const [caseStatus, setCaseStatus] = useState(
    newCaseKey ? "NEW_CASE" : "UPLOAD_DOCUMENT",
  );
  const [subRequestType, setSubRequestType] = useState("");
  const [isTpa, setIsTpa] = useState("");
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [proceedClicked, setProceedClicked] = useState(false);
  const [isViewDetailPopupVisible, setIsViewDetailPopupVisible] =
    useState(false);
  const [isLogPopupVisible, setIsLogPopupVisible] = useState(false);
  const [
    isUpdateMultipleRequestStatusPopupVisible,
    setIsUpdateMultipleRequestStatusPopupVisible,
  ] = useState(false);
  const [selectedRequestIds, setSelectedRequestIds] = useState([]);
  const searchTimeRef = useRef(null);
  const limit = 10;
  const [applicationId, setApplicationId] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRpaLog, setSelectedRpaLog] = useState(null);

  const [hospitalList, setHospitalList] = useState([]);
  const [startDate, setStartDate] = useState(
    new Date(new Date().setDate(new Date().getDate() - 60)),
  );
  const [endDate, setEndDate] = useState(
    new Date().setDate(new Date().getDate() + 1),
  );
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [formData, setFormData] = useState({
    hospitalId: "",
    caseStatus: "NEW_CASE",
    pmjayCaseId: "",
    pmjayRegistrationId: "",
    requestType: "NEW",
    statusRemark: "Manually Added",
  });
  const [selectedTab, setSelectedTab] = useState("Pending");
  const { newCaseNotificationCount } = useSelector(
    (store) => store.notificationReducer,
  );
  const { rpaRunningHospitals } = useSelector(
    (store) => store.hospitalDetailsReducer,
  );

  const dispatch = useDispatch();
  const togglePasswordVisibility = (hospitalId) => {
    setIsPasswordVisible((prevId) =>
      prevId === hospitalId ? null : hospitalId,
    );
  };

  const handleSearch = (e) => {
    if (searchTimeRef.current) {
      clearInterval(searchTimeRef.current);
    }
    searchTimeRef.current = setTimeout(() => {
      setSearchKey(e.target.value);
      setPage(1);
    }, 500);
  };

  const handleButtonClick = () => {
    setPopupOpen(!isPopupOpen);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    const idFields = ["pmjayCaseId", "pmjayRegistrationId"];

    let newValue = value;

    if (idFields.includes(name)) {
      newValue = value.replace(/\D/g, "").slice(0, 20);
    }

    setFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    let data = {};
    if (formData.caseStatus === "STATUS_UPDATE") {
      if (selectedHospital.tmsVersion === "1.0") {
        data = {
          hospitalId: formData.hospitalId,
          caseStatus: formData.caseStatus,
          pmjayCaseId: formData.pmjayCaseId,
          requestType: formData.requestType,
          statusRemark: "Manually Added",
        };
      } else {
        data = {
          hospitalId: formData.hospitalId,
          caseStatus: formData.caseStatus,
          pmjayRegistrationId: formData.pmjayRegistrationId,
          requestType: formData.requestType,
          statusRemark: "Manually Added",
        };
      }
    } else {
      data = {
        hospitalId: formData.hospitalId,
        caseStatus: "NEW_CASE",
        statusRemark: "Manually Added",
      };
    }

    try {
      const response = await RpaServices.addRpaRequest(data);
      if (response?.status === 201) {
        alert("Request added successfully!");
        setPopupOpen(false);
        await fetchrpaLogs(selectedTab);
        setFormData({
          hospitalId: "",
          caseStatus: "",
          pmjayCaseId: "",
          pmjayRegistrationId: "",
          requestType: null,
          statusRemark: "Manually Added",
        });
      } else {
        alert(response?.data?.message || "Request failed. Please try again.");
      }
    } catch (error) {
      handleApiErrorResponses(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchrpaLogs = async (selection) => {
    setIsLoading(true);
    setRpaLogs([]);

    // ✅ Normalize dates to full UTC day
    const startUTC = new Date(startDate);
    startUTC.setUTCHours(0, 0, 0, 0);

    const endUTC = new Date(endDate);
    endUTC.setUTCHours(23, 59, 59, 999);

    try {
      let res;

      if (selection === "Pending") {
        res = await RpaServices.manageRpaLogs(
          applicationId,
          searchKey,
          page,
          limit,
          startUTC,
          endUTC,
          hospitalId,
          requestStatus,
          caseStatus,
          subRequestType,
          isTpa,
        );
      } else {
        res = await RpaServices.manageRpaProcessedLogs(
          applicationId,
          searchKey,
          page,
          limit,
          startUTC,
          endUTC,
          hospitalId,
          requestStatus,
          caseStatus,
          isTpa,
        );
      }

      // Response handling logic here...
      if (selection === "Pending") {
        if (res?.data?.requests) {
          const modifiedData = res.data.requests.map((request) => {
            const isRunning = rpaRunningHospitals?.includes(request.hospitalId);
            return {
              ...request,
              oldRequestStatus:
                request.oldRequestStatus || request.requestStatus,
              requestStatus: isRunning ? "RUNNING" : request.requestStatus,
            };
          });
          setRpaLogs(modifiedData);
          setTotalPages(res.data.totalPages || 1);
          setTotal(res.data.total || 0);
        }
      } else {
        if (res?.data?.processedRequests) {
          setRpaLogs(res.data.processedRequests);
          setTotalPages(res.data.totalPages || 1);
          setTotal(res.data.total || 0);
        }
      }
    } catch (error) {
      handleApiErrorResponses(error);
    } finally {
      // ✅ Always reset loading state, no matter success or error
      setIsLoading(false);
    }
  };

  const handleMenuOpen = (event, rpalog) => {
    const fallbackStatus = rpalog.oldRequestStatus || rpalog.requestStatus;
    rpalog.oldRequestStatus = fallbackStatus; // Ensure it's always set
    setAnchorEl(event.currentTarget);
    setSelectedRpaLog(rpalog);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRpaLog(null);
  };

  const handleStatusUpdate = () => {
    if (selectedRpaLog) {
      setSelectedUser(selectedRpaLog);
      setIsPopupVisible(true);
    }
    handleMenuClose();
  };

  const handleViewDetail = () => {
    if (selectedRpaLog) {
      setSelectedUser(selectedRpaLog);
      setIsViewDetailPopupVisible(true);
    }
    handleMenuClose();
  };

  const handleLog = () => {
    if (selectedRpaLog) {
      setSelectedUser(selectedRpaLog);
      setIsLogPopupVisible(true);
    }
    handleMenuClose();
  };

  const getHospitalList = async () => {
    try {
      const response = await HospitalServices.gethospitals("", 1, 1500);
      setHospitalList(response.data.list);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  const formatDate = (date) => {
    date = new Date(date);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleStartDateChange = (e) => {
    const selected = new Date(e.target.value);
    setStartDate(selected); // no time normalization here
  };

  const handleEndDateChange = (e) => {
    const selected = new Date(e.target.value);
    setEndDate(selected); // no time normalization here
  };

  const handleSaveChanges = async () => {
    const data = {
      requestId: selectedUser?.id,
      requestStatus: newStatus,
      oldStatus: selectedUser?.oldRequestStatus || selectedUser?.requestStatus,
      statusRemark: "Manually Updated",
    };

    try {
      setIsLoading(true);
      const response = await RpaServices.updateRpaRequest(data);
      console.log("Sending data", data);
      if (response?.status === 200) {
        alert("Changes saved successfully!");
        setIsPopupVisible(false);
        await fetchrpaLogs(selectedTab);
        dispatch(fetchNewCaseNotificationCount());
      } else {
        alert("Failed to update rpa details.");
      }
    } catch (error) {
      handleApiErrorResponses(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchrpaLogs(selectedTab);
  }, [
    applicationId,
    page,
    limit,
    searchKey,
    startDate,
    endDate,
    hospitalId,
    requestStatus,
    selectedTab,
    caseStatus,
    newCaseNotificationCount,
    subRequestType,
    isTpa,
  ]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getHospitalList();
  }, []);

  useEffect(() => {
    if (rpaRunningHospitals && rpaRunningHospitals?.length > 0) {
      for (let hospitalId of rpaRunningHospitals) {
        let idx = 0;
        for (let log of rpaLogs) {
          rpaLogs[idx].oldRequestStatus =
            rpaLogs[idx]?.oldRequestStatus || rpaLogs[idx].requestStatus;
          if (log.hospitalId === hospitalId) {
            rpaLogs[idx].requestStatus = "RUNNING";
          }
          idx++;
        }
      }
      setRpaLogs([...rpaLogs]);
    } else {
      fetchrpaLogs(selectedTab);
    }
  }, [rpaRunningHospitals]);
  const changeSelectedTab = (selection) => {
    setSelectedTab(selection);
    fetchrpaLogs(selection);
  };

  const dateOptions = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  };

  // console.log("selected hospital:", selectedHospital);
  console.log("selectedRequestIds:", selectedRequestIds);

  return (
    <div className="initiateadmission-box">
      <span className="path_line">
        <WidgetsOutlinedIcon style={{ height: "24px" }} /> &nbsp;/ &nbsp;
        Dashboard &nbsp;/ &nbsp; RPA Request Management
      </span>

      <div className="flex justify-between items-center">
        <div className="heading flex items-end">
          RPA Request Management{" "}
          <span className="font-medium ml-1">{`(${total})`}</span>{" "}
        </div>

        <div className="flex gap-4 mb-4">
          <button
            className={`text-sm font-semibold px-6 py-2 rounded-full ${
              selectedTab === "Pending"
                ? "bg-[#017C57] text-white"
                : "bg-white text-[#017C57] border border-solid border-[#017C57]"
            }`}
            onClick={() => changeSelectedTab("Pending")}
          >
            Pending
          </button>
          <button
            className={`text-sm font-semibold px-6 py-2 rounded-full ${
              selectedTab === "Processed"
                ? "bg-[#017C57] text-white"
                : "bg-white text-[#017C57] border border-[#017C57]"
            }`}
            onClick={() => changeSelectedTab("Processed")}
          >
            Processed
          </button>
          <div className="flex items-center gap-2 rounded-full border border-[#D4D4D4] bg-[#F5F5F5] px-4 py-[6px] focus-within:border-[#9CA3AF] focus-within:bg-white focus-within:shadow-sm transition-colors">
            <img
              src={SearchIcon}
              alt="search-icon"
              className="w-4 h-4 opacity-70"
            />
            <input
              type="text"
              placeholder="Search anything"
              className="outline-none border-0 bg-transparent text-sm text-[#111827] placeholder:text-[#9CA3AF] w-48"
              onChange={handleSearch}
            />
          </div>
        </div>
      </div>
      <hr style={{ color: "#E7E7E7", marginBottom: "20px" }} />

      <div className="flex justify-end items-center gap-3 mb-5">
        <div className="min-w-[200px]">
          <Select
            name="scheme"
            isClearable
            options={[
              { value: 0, label: "PMJAY" },
              { value: 1, label: "TPA" },
            ]}
            onChange={(item) => {
              setPage(1);
              setIsTpa(item ? item.value : "");
            }}
            value={[
              { value: 0, label: "PMJAY" },
              { value: 1, label: "TPA" },
            ].filter((option) => option.value === isTpa)}
            placeholder="FILTER SCHEME WISE"
          />
        </div>
        <button
          className="text-sm text-[#017C57] font-semibold px-6 py-1 rounded-full bg-white border border-[#017C57]  sm:w-auto cursor-pointer"
          onClick={() => setIsUpdateMultipleRequestStatusPopupVisible(true)}
        >
          Update Multiple Requests Status
        </button>
      </div>

      {/* Add Filters Here */}
      <div className="flex justify-between items-center">
        <div className="flex gap-3 mb-4">
          <div>
            <label htmlFor="start-date">Start Date:</label>
            <input
              type="date"
              id="start-date"
              value={formatDate(startDate)}
              onChange={handleStartDateChange}
              max={formatDate(new Date())}
              style={{ border: "1px solid #E5E5E5" }}
              className="text-[#191919] appearance-none p-2 rounded-[8px]"
            />
          </div>

          <div>
            <label htmlFor="end-date">End Date:</label>
            <input
              type="date"
              id="end-date"
              value={formatDate(endDate)}
              onChange={handleEndDateChange}
              max={formatDate(new Date())}
              style={{ border: "1px solid #E5E5E5" }}
              className="text-[#191919] appearance-none p-2 rounded-[8px]"
            />
          </div>

          <Select
            name="hospitalId"
            isClearable
            options={hospitalList}
            getOptionLabel={(options) => options["name"]}
            getOptionValue={(options) => options["id"]}
            onChange={(item) => {
              setPage(1);
              item ? setHospitalId(item.id) : setHospitalId("");
            }}
            value={hospitalList.filter((item) => item.id === hospitalId)}
            placeholder="FILTER HOSPITAL WISE"
          />

          <Select
            name="status"
            isClearable
            options={[
              { label: "New", value: "NEW" },
              { label: "Hold", value: "HOLD" },
              { label: "Completed", value: "COMPLETED" },
              { label: "Start Manually", value: "STARTMANUALLY" },
            ]}
            getOptionLabel={(options) => options["label"]}
            getOptionValue={(options) => options["value"]}
            onChange={(item) => {
              setPage(1);
              item ? setRequestStatus(item.value) : setRequestStatus("");
            }}
            value={[
              { label: "New", value: "NEW" },
              { label: "Hold", value: "HOLD" },
              { label: "Completed", value: "COMPLETED" },
              { label: "Start Manually", value: "STARTMANUALLY" },
            ].filter((option) => option.value === requestStatus)}
            placeholder="FILTER STATUS WISE"
          />
          <Select
            name="caseStatus"
            isClearable
            options={[
              { label: "New Case", value: "NEW_CASE" },
              { label: "Status Update", value: "STATUS_UPDATE" },
              { label: "Upload Document", value: "UPLOAD_DOCUMENT" },
              { label: "Claim Update", value: "CLAIM_UPDATE" },
              { label: "Erroneous Claim", value: "ERRONEOUS_CLAIM" },
              { label: "Reprocess Claim", value: "REPROCESS_CLAIM" },
            ]}
            getOptionLabel={(options) => options["label"]}
            getOptionValue={(options) => options["value"]}
            onChange={(item) => {
              setPage(1);
              item ? setCaseStatus(item.value) : setCaseStatus("");
            }}
            value={[
              { label: "New Case", value: "NEW_CASE" },
              { label: "Status Update", value: "STATUS_UPDATE" },
              { label: "Upload Document", value: "UPLOAD_DOCUMENT" },
              { label: "Claim Update", value: "CLAIM_UPDATE" },
              { label: "Erroneous Claim", value: "ERRONEOUS_CLAIM" },
              { label: "Reprocess Claim", value: "REPROCESS_CLAIM" },
            ].filter((option) => option.value === caseStatus)}
            placeholder="FILTER REQUEST TYPE WISE"
          />

          <Select
            name="caseStatus"
            isClearable
            options={[
              { label: "Preauth", value: "PREAUTH" },
              { label: "Enhancement", value: "ENHANCEMENT" },
              { label: "Claim", value: "CLAIM" },
            ]}
            getOptionLabel={(options) => options["label"]}
            getOptionValue={(options) => options["value"]}
            onChange={(item) => {
              setPage(1);
              item ? setSubRequestType(item.value) : setSubRequestType("");
            }}
            value={[
              { label: "Preauth", value: "PREAUTH" },
              { label: "Enhancement", value: "ENHANCEMENT" },
              { label: "Claim", value: "CLAIM" },
            ].filter((option) => option.value === subRequestType)}
            placeholder="FILTER SUB REQUEST WISE"
          />

          <button
            className="text-sm text-[#017C57] font-semibold px-6 py-1 rounded-full bg-white border border-[#017C57]  sm:w-auto"
            onClick={handleButtonClick}
          >
            Add Request
          </button>

          {isPopupOpen && (
            <div className="fixed z-20 inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center">
              <div
                className="bg-white p-6 rounded-lg shadow-lg relative"
                style={{ width: "640px", marginTop: "50px" }}
              >
                <div className="px-0 pt-0 pb-4 border-b-2 border-s-2 border-gray-100 flex justify-between">
                  <div className="left-10 top-6 cursor-pointer font-semibold text-[18px]">
                    Add Request
                  </div>
                  <div className="right-12 top-6 cursor-pointer">
                    <Close
                      className="absolute top-6 right-6 font-semibold text-xl hover:text-gray-700"
                      alt="close-icon"
                      onClick={() => {
                        handleButtonClick();
                      }}
                    />
                  </div>
                </div>

                <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                  <div>
                    <label className="block font-medium mb-1">Hospital</label>
                    <Select
                      options={hospitalList}
                      getOptionLabel={(options) => options["name"]}
                      getOptionValue={(options) => options["id"]}
                      onChange={(selectedOption) => {
                        setFormData((prev) => ({
                          ...prev,
                          ["hospitalId"]: selectedOption.id,
                        }));
                        setSelectedHospital(selectedOption);
                      }}
                      placeholder="Select Hospital"
                    />
                  </div>

                  <div>
                    <label className="block font-medium mb-1">
                      Request Type
                    </label>

                    <Select
                      options={[
                        { value: "STATUS_UPDATE", label: "STATUS UPDATE" },
                        // { value: "UPLOAD_DOC", label: "UPLOAD DOCUMENT" },
                        { value: "NEW_CASE", label: "NEW CASE" },
                      ]}
                      onChange={(selectedOption) => {
                        setFormData((prev) => ({
                          ...prev,
                          ["caseStatus"]: selectedOption.value,
                        }));
                      }}
                      value={[
                        { value: "STATUS_UPDATE", label: "STATUS UPDATE" },
                        // { value: "UPLOAD_DOC", label: "UPLOAD DOCUMENT" },
                        { value: "NEW_CASE", label: "NEW CASE" },
                      ].filter((item) => item.value === formData.caseStatus)}
                      placeholder="Select Request Type"
                    />
                  </div>

                  {formData.caseStatus === "STATUS_UPDATE" && (
                    <div>
                      <label className="block font-medium mb-1">
                        Request Sub Type
                      </label>

                      <Select
                        name="requestType"
                        options={[
                          { value: "PREAUTH", label: "PREAUTH" },
                          { value: "CLAIM", label: "CLAIM" },
                        ]}
                        onChange={(selectedOption) => {
                          setFormData((prev) => ({
                            ...prev,
                            ["requestType"]: selectedOption.value,
                          }));
                        }}
                        placeholder="Select Request Sub Type"
                      />
                    </div>
                  )}

                  {formData.caseStatus === "STATUS_UPDATE" && (
                    <div>
                      <label className="block font-medium mb-1">
                        {selectedHospital?.tmsVersion === "1.0"
                          ? "PmjayCase ID"
                          : "Registration ID"}
                      </label>
                      <input
                        type="text"
                        name={
                          selectedHospital.tmsVersion === "1.0"
                            ? "pmjayCaseId"
                            : "pmjayRegistrationId"
                        }
                        value={
                          selectedHospital.tmsVersion === "1.0"
                            ? formData.pmjayCaseId
                            : formData.pmjayRegistrationId
                        }
                        onChange={handleInputChange}
                        maxLength={20}
                        className="w-full border border-gray-300 rounded p-2 focus:outline-none focus:ring-2 focus:ring-[#017C57]"
                        placeholder="Enter pmjayCaseId"
                        required
                      />
                    </div>
                  )}

                  <button
                    type="submit"
                    className="text-sm text-white bg-[#017C57] py-2 px-4 mt-2 rounded-full border-none cursor-pointer"
                  >
                    Submit
                  </button>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="Second-container">
        <div className="flex justify-between">
          {!isLoading ? (
            rpaLogs?.length > 0 ? (
              <section className="mt-1">
                <div className="grid grid-cols-11 text-[#191919] font-semibold py-1 gap-2 items-center">
                  {/* Empty label for checkboxes column */}
                  <div className="text-[18px] flex items-center justify-center gap-1">
                    <input
                      type="checkbox"
                      checked={
                        rpaLogs.length > 0 &&
                        rpaLogs.every((log) =>
                          selectedRequestIds.includes(log.id),
                        )
                      }
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedRequestIds((prev) => {
                            const pageIds = rpaLogs.map((log) => log.id);
                            const merged = new Set([...prev, ...pageIds]);
                            return [...merged];
                          });
                        } else {
                          setSelectedRequestIds((prev) => {
                            const pageIds = new Set(
                              rpaLogs.map((log) => log.id),
                            );
                            return prev.filter((id) => !pageIds.has(id));
                          });
                        }
                      }}
                    />
                    <span className="text-[15px] whitespace-nowrap text-[#017C57] font-semibold">
                      Select All
                    </span>
                  </div>
                  <div className="text-[18px]">Request Status</div>
                  <div className="text-[18px]">Request Time</div>
                  <div className="text-[18px]">Case Status</div>
                  <div className="text-[18px]">RPA Request Type</div>
                  <div className="text-[18px]">Request By</div>
                  <div className="text-[18px]">Registration Id</div>
                  <div className="text-[18px]">Request To (Application ID)</div>
                  <div className="text-[18px]">Status Update Time</div>
                  <div className="text-[18px]">RPA Attempts</div>
                  <div className="text-[18px] text-center">Action</div>
                </div>

                {rpaLogs.map((rpalog, idx) => (
                  <article
                    key={idx}
                    className={`py-6 rounded-[16px] ${
                      idx % 2 === 0 ? "bg-white" : "bg-[#F9F9F9]"
                    }`}
                  >
                    <div className="grid grid-cols-11 text-[#797979] text-[18px] gap-2 items-center">
                      {/* Checkbox column */}
                      <div className="flex items-center justify-center">
                        <input
                          type="checkbox"
                          checked={selectedRequestIds.includes(rpalog.id)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedRequestIds((prev) => [
                                ...prev,
                                rpalog.id,
                              ]);
                            } else {
                              setSelectedRequestIds((prev) =>
                                prev.filter((id) => id !== rpalog.id),
                              );
                            }
                          }}
                        />
                      </div>
                      <div className="text-[18px]">
                        <img
                          src={
                            rpalog?.requestStatus == "NEW"
                              ? yellow
                              : rpalog?.requestStatus == "COMPLETED"
                                ? Animation
                                : rpalog?.requestStatus == "RUNNING"
                                  ? RunningAnimation
                                  : rpalog?.requestStatus == "STARTMANUALLY"
                                    ? StartedManually
                                    : RedAnimation
                          }
                          alt={
                            rpalog?.requestStatus == "NEW"
                              ? "NEW CASE"
                              : rpalog?.requestStatus == "COMPLETED"
                                ? "COMPLETED"
                                : rpalog?.requestStatus == "RUNNING"
                                  ? "RUNNING"
                                  : rpalog?.requestStatus == "STARTMANUALLY"
                                    ? "START MANUALLY"
                                    : "HOLD"
                          }
                          title={
                            rpalog?.requestStatus == "NEW"
                              ? "NEW CASE"
                              : rpalog?.requestStatus == "COMPLETED"
                                ? "COMPLETED"
                                : rpalog?.requestStatus == "RUNNING"
                                  ? "RUNNING"
                                  : rpalog?.requestStatus == "STARTMANUALLY"
                                    ? "Manually Started"
                                    : "HOLD"
                          }
                          className="w-6 h-6"
                        />

                        {rpalog?.rpaUpdates?.statusRemark && (
                          <span className="group relative w-fit">
                            <InfoOutlinedIcon className="relative text-[#017C57] ml-3" />
                            <div className="absolute hidden group-hover:block text-[12px] text-nowrap bg-[#191919] text-white top-6 left-[50%] p-1 rounded-[4px]">
                              {rpalog?.rpaUpdates
                                ? rpalog?.rpaUpdates?.statusRemark
                                : "--"}
                            </div>
                          </span>
                        )}
                        <div className="text-[12px]">
                          {rpalog?.requestStatus == "NEW"
                            ? "New Case"
                            : rpalog?.requestStatus == "COMPLETED"
                              ? "Completed"
                              : rpalog?.requestStatus == "RUNNING"
                                ? "Rpa Running"
                                : rpalog?.requestStatus == "STARTMANUALLY"
                                  ? "Manually Started"
                                  : "Waiting For Manual"}
                        </div>
                      </div>
                      <div className="text-[18px]">
                        {rpalog?.createdAt
                          ? new Date(rpalog.createdAt).toLocaleString(
                              "en-GB",
                              dateOptions,
                            )
                          : "NA"}
                      </div>
                      <div className="text-[18px]">
                        {rpalog?.caseStatus?.replace("_", " ") || "NA"}
                      </div>
                      <div className="text-[18px]">
                        {rpalog?.requestType
                          ? (rpalog?.requestType).replace("_", " ") || "--"
                          : "--"}
                      </div>
                      <div className="text-[18px]">
                        {rpalog?.hospitalId
                          ? hospitalList.filter(
                              (item) => item.id === rpalog?.hospitalId,
                            )[0]?.name
                          : "--"}
                      </div>
                      <div
                        className="text-[18px]"
                        title={rpalog?.pmjayRegistrationId}
                        onCopy={(e) => {
                          if (rpalog?.pmjayRegistrationId) {
                            e.preventDefault();
                            e.clipboardData.setData(
                              "text/plain",
                              rpalog.pmjayRegistrationId,
                            );
                          }
                        }}
                      >
                        {rpalog?.pmjayRegistrationId
                          ? `${rpalog.pmjayRegistrationId.slice(0, 6)}...`
                          : "--"}
                      </div>
                      <div className="text-[18px]">
                        {rpalog?.hospital?.applicationId
                          ? rpalog?.hospital?.applicationId
                          : "---"}
                      </div>

                      <div className="text-[18px]">
                        {(rpalog?.completionDate
                          ? new Date(rpalog?.completionDate).toLocaleString(
                              "en-GB",
                              {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                second: "2-digit",
                                hour12: true,
                              },
                            )
                          : " ") +
                          (rpalog?.rpaUpdates?.statusRemark
                            ? rpalog?.rpaUpdates?.statusRemark
                            : "")}
                      </div>
                      <div className="text-[18px] text-center">
                        {rpalog?.attempt || 0}
                      </div>
                      <div className="flex justify-center items-center gap-2">
                        <MoreVertIcon
                          onClick={(event) => handleMenuOpen(event, rpalog)}
                          className="cursor-pointer"
                        />
                        <Menu
                          anchorEl={anchorEl}
                          open={Boolean(anchorEl)}
                          onClose={handleMenuClose}
                        >
                          {selectedTab == "Pending" ? (
                            <MenuItem onClick={handleStatusUpdate}>
                              Status Update
                            </MenuItem>
                          ) : (
                            ""
                          )}
                          <MenuItem onClick={handleViewDetail}>
                            View Detail
                          </MenuItem>
                          <MenuItem onClick={handleLog}>Log</MenuItem>
                        </Menu>
                        {rpalog?.requestStatus !== "COMPLETED" && (
                          <div
                            className="cursor-pointer"
                            onClick={() => {
                              setProceedClicked(rpalog);
                            }}
                          >
                            Proceed
                          </div>
                        )}
                      </div>
                    </div>
                  </article>
                ))}
              </section>
            ) : (
              <div className="w-full h-full flex justify-center items-center font-semibold text-xl text-[#191919]">
                No Data Found
              </div>
            )
          ) : (
            <div className="w-full h-[500px] flex justify-center items-center">
              <CircularProgress />
            </div>
          )}
        </div>
      </div>

      {isPopupVisible && (
        <div className="popup-overlay">
          <div className="popup-container relative h-[300px] w-[328px] xl:w-[50%] bg-white rounded-[16px] pb-0 xl:p-0 z-[1200]">
            <div className="absolute right-12 top-8 cursor-pointer">
              <Close
                alt="close-icon"
                onClick={() => {
                  setIsPopupVisible(false);
                }}
              />
            </div>

            <div className="space-y-4">
              <div className="flex pt-6 pl-10 gap-2">
                <div className="w-[776px] p-[16px] border border-[rgba(228,228,228,1)] rounded-[8px] flex flex-col gap-[16px]">
                  <div className="flex flex-col gap-4">
                    <label className="text-[#191919] text-[18px] font-semibold">
                      Update Request Status
                    </label>
                    <div className="flex flex-col gap-2">
                      <label className="flex items-center gap-2">
                        <input
                          type="radio"
                          name="requestStatus"
                          value="NEW"
                          checked={newStatus === "NEW"}
                          onChange={(e) => setnewStatus(e.target.value)}
                        />
                        <span>NEW</span>
                      </label>
                      <label className="flex items-center gap-2">
                        <input
                          type="radio"
                          name="requestStatus"
                          value="HOLD"
                          checked={newStatus === "HOLD"}
                          onChange={(e) => setnewStatus(e.target.value)}
                        />
                        <span>HOLD</span>
                      </label>
                      <label className="flex items-center gap-2">
                        <input
                          type="radio"
                          name="requestStatus"
                          value="COMPLETED"
                          checked={newStatus === "COMPLETED"}
                          onChange={(e) => setnewStatus(e.target.value)}
                        />
                        <span>COMPLETED</span>
                      </label>
                      <label className="flex items-center gap-2">
                        <input
                          type="radio"
                          name="requestStatus"
                          value="STARTMANUALLY"
                          checked={newStatus === "STARTMANUALLY"}
                          onChange={(e) => setnewStatus(e.target.value)}
                        />
                        <span>STARTMANUALLY</span>
                      </label>
                    </div>
                  </div>

                  <div className="flex justify-center mt-9">
                    <div className="text-white text-xs font-semibold bg-[#017C57] rounded-full py-1 px-2 cursor-pointer">
                      <button
                        onClick={handleSaveChanges}
                        className="save-button"
                      >
                        Save Changes
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {isViewDetailPopupVisible && (
        <div className="popup-overlay">
          <div className="popup-container relative h-[400px] w-[328px] xl:w-[50%] bg-white rounded-[16px] pb-0 xl:p-0 z-[1200]">
            <div className="absolute right-12 top-8 cursor-pointer">
              <Close
                alt="close-icon"
                onClick={() => {
                  setIsViewDetailPopupVisible(false);
                }}
              />
            </div>

            <div className="space-y-4 p-6">
              <h2 className="text-[#191919] text-[24px] font-semibold">
                View Details
              </h2>
              <div className="flex flex-col gap-4">
                <div>
                  <label className="text-[#191919] text-[18px] font-semibold">
                    Request Status:
                  </label>
                  <p>{selectedUser?.requestStatus || "No data available"}</p>
                </div>
                <div>
                  <label className="text-[#191919] text-[18px] font-semibold">
                    Request Time:
                  </label>
                  <p>
                    {new Date(selectedUser?.createdAt).toLocaleString(
                      "en-GB",
                      dateOptions,
                    )}
                  </p>
                </div>
                <div>
                  <label className="text-[#191919] text-[18px] font-semibold">
                    Request Type:
                  </label>
                  <p>
                    {selectedUser?.requestType
                      ? selectedUser?.requestType?.replace("_", " ")
                      : "-"}
                  </p>
                </div>
                <div>
                  <label className="text-[#191919] text-[18px] font-semibold">
                    Hospital Details
                  </label>
                  <p>
                    <b>Name :</b>
                    {selectedUser?.hospitalId
                      ? hospitalList.find(
                          (item) => item.id === selectedUser?.hospitalId,
                        )?.name
                      : "--"}
                  </p>
                  <p>
                    <b>Code :</b>{" "}
                    {selectedUser?.hospitalId
                      ? hospitalList.find(
                          (item) => item.id === selectedUser?.hospitalId,
                        )?.code
                      : "--"}
                  </p>
                  <p>
                    <b>City :</b>{" "}
                    {selectedUser?.hospitalId
                      ? hospitalList.find(
                          (item) => item.id === selectedUser?.hospitalId,
                        )?.city
                      : "--"}
                  </p>
                </div>
                <div>
                  <label className="text-[#191919] text-[18px] font-semibold">
                    Request To (Application ID):
                  </label>
                  <p>{selectedUser?.applicationId}</p>
                </div>
                <div>
                  <label className="text-[#191919] text-[18px] font-semibold">
                    Status Update Time:
                  </label>
                  <p>
                    {selectedUser?.completionDate
                      ? new Date(selectedUser?.completionDate).toLocaleString(
                          "en-GB",
                          dateOptions,
                        )
                      : "NA"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {isLogPopupVisible && (
        <div className="popup-overlay">
          <div className="popup-container relative h-[400px] w-[328px] xl:w-[50%] bg-white rounded-[16px] pb-0 xl:p-0 z-[1200]">
            <div className="absolute right-12 top-8 cursor-pointer">
              <Close
                alt="close-icon"
                onClick={() => {
                  setIsLogPopupVisible(false);
                }}
              />
            </div>

            <div className="space-y-4 p-6">
              <h2 className="text-[#191919] text-[24px] font-semibold">
                Log Details
              </h2>
              <div className="flex flex-col gap-4">
                <div>
                  <label className="text-[#191919] text-[18px] font-semibold">
                    Request ID:
                  </label>
                  <p>{selectedUser?.id}</p>
                </div>
                <div>
                  <label className="text-[#191919] text-[18px] font-semibold">
                    Request Type:
                  </label>
                  <p>
                    {selectedUser?.requestType
                      ? selectedUser?.requestType?.replace("_", " ")
                      : "-"}
                  </p>
                </div>
                <div>
                  <label className="text-[#191919] text-[18px] font-semibold">
                    Request By:
                  </label>
                  <p>
                    {selectedUser?.hospitalId
                      ? hospitalList.find(
                          (item) => item.id === selectedUser?.hospitalId,
                        )?.name
                      : "--"}
                  </p>
                </div>
                <div>
                  <label className="text-[#191919] text-[18px] font-semibold">
                    Request To (Application ID):
                  </label>
                  <p>{selectedUser?.applicationId}</p>
                </div>
                <div>
                  <label className="text-[#191919] text-[18px] font-semibold">
                    Remarks:
                  </label>
                  <ul>
                    {selectedUser?.rpaUpdates?.map((update, index) => (
                      <li key={index}>{update.remark}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {proceedClicked &&
        (proceedClicked?.caseStatus === "NEW_CASE" ? (
          <AddNewCaseFromRpa
            setOpen={setProceedClicked}
            selectedRpaLog={proceedClicked}
          />
        ) : proceedClicked?.caseStatus === "STATUS_UPDATE" ? (
          <AddPmjayQuery
            selectedRpaLog={proceedClicked}
            setProceedClicked={setProceedClicked}
            fetchrpaLogs={fetchrpaLogs}
          />
        ) : (
          <DownloadDocumentsForRpa
            setOpen={setProceedClicked}
            selectedRpaLog={proceedClicked}
            fetchrpaLogs={fetchrpaLogs}
          />
        ))}
      {isUpdateMultipleRequestStatusPopupVisible && (
        <UpdateMultipleRequestStatus
          setOpen={setIsUpdateMultipleRequestStatusPopupVisible}
          requestIds={selectedRequestIds}
          oldStatus={requestStatus}
        />
      )}
      <div className="flex justify-center mt-4">
        <CustomPagination
          page={page}
          setPage={setPage}
          totalPages={totalPages}
        />
      </div>
    </div>
  );
};

export default ManagedRpaLogs;
